module.exports = __webpack_public_path__ + "static/media/sword1.d74eb0b7.mp3";